import { atom } from "jotai";

export const nextButtonRefAtom = atom<HTMLButtonElement | null>(null);
